import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const SabalUserPermissionsUpdated = ({ event }: { event: any }) => {
  const { username, newPermissions, addedPermissions, removedPermissions } = event.data;
  const hasDiff = addedPermissions !== undefined || removedPermissions !== undefined;

  return (
    <Box display="block">
      <EventBy event={event} /> updated the permissions for <strong>{username}</strong>
      {hasDiff ? (
        <Box childGap="2xs" margin="2xs 0 0 0">
          {addedPermissions && (
            <Box fontSize="sm">
              <strong>Added:</strong> {addedPermissions}
            </Box>
          )}
          {removedPermissions && (
            <Box fontSize="sm">
              <strong>Removed:</strong> {removedPermissions}
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          <strong>New Permissions: {newPermissions}</strong>
        </Box>
      )}
    </Box>
  );
};

export default SabalUserPermissionsUpdated;
